import { CogsEstimationForm } from "@redux/reducers/cogsEstimationReducer";

export enum ActionType {
  COGS_DETAILS_BY_ID = "COGS_DETAILS_BY_ID",
}

export interface ICogsDetailsByid {
  type: ActionType.COGS_DETAILS_BY_ID;
  payload: CogsEstimationForm[];
}

export type Action = ICogsDetailsByid;
